module.exports = __webpack_public_path__ + "static/media/bronze.9c0de7b7.svg";